const faImages = {
  prefix: 'fal',
  iconName: 'images',
  icon: [
    576,
    512,
    [],
    'f302',
    'M160 64c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L160 64zM96 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64L96 96zM32 144l0 304c0 17.7 14.3 32 32 32l368 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64L0 144c0-8.8 7.2-16 16-16s16 7.2 16 16zm176-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm89.3 51.7l-38.6 60c-2.8 4.4-7.6 7.1-12.9 7.3s-10.2-2.2-13.4-6.4l-10.1-13.4c-1.5-2-3.9-3.2-6.4-3.2s-4.9 1.2-6.4 3.2l-48 64c-1.8 2.4-2.1 5.7-.8 8.4S213 320 216 320l208 0c2.9 0 5.6-1.6 7-4.2s1.3-5.7-.3-8.2l-72-112c-1.5-2.3-4-3.7-6.7-3.7s-5.3 1.4-6.7 3.7zM352 160c13.6 0 26.3 6.9 33.6 18.4l72 112c7.9 12.3 8.5 28 1.5 40.8S438.6 352 424 352l-208 0c-15.2 0-29-8.6-35.8-22.1s-5.3-29.8 3.8-41.9l48-64c7.6-10.1 19.4-16 32-16 10.5 0 20.6 4.2 28 11.4l26.4-41c7.4-11.4 20-18.4 33.6-18.4z',
  ],
};
export default faImages;
